import Button from 'components/common/Buttons/index';
import HeroTrastpilot from 'components/Sections/Hero/HeroTrastpilot';
import HeroCrumbs from 'components/Sections/Hero/HeroCrumbs';
import GoogleButton from 'components/common/Buttons/GoogleButton';
import { selectHomepageTags } from 'store/slices/HomepageSlice';
import { useSelector } from 'react-redux';


const HeroComponent = ({ title, desc, hasCrumbs = false, btnText, button_text_link }) => {

    const homeTags = useSelector(selectHomepageTags)


    return (
        <div className={`${hasCrumbs ? 'hero-container--with-crumbs' : ''}`}>
            {hasCrumbs && <HeroCrumbs page={title} />}
            <HeroTrastpilot />
            <div className="hero-body">
                <h1 className='hero-body__title'>{title}</h1>
                <div className="body1 hero-body__desc">{desc}</div>
            </div>
            <div className='hero-body-buttons'>
                <Button text={btnText} to={button_text_link} target={true} />

                {
                    homeTags.start_with_google_button && <GoogleButton />
                }

            </div>
        </div>
    );
};

export default HeroComponent;